/* ad-stone-gallery.js — Loose Diamonds picker: clean cards + 360 stage (vanilla) */
(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }

  function init(root) {
    var handle = root.getAttribute('data-collection') || 'loose-diamonds';
    var viewerBase = root.getAttribute('data-viewer-base') || 'https://pkonline.blob.core.windows.net/pkonline';
    var ringUrl = root.getAttribute('data-ring-url') || '/pages/design-your-ring';
    var listEl = $('.ad-sg__list', root), countEl = $('.ad-sg__count', root), moreBtn = $('.ad-sg__more', root);
    var stage = {
      frameWrap: $('.ad-sg__viewer', root), title: $('.ad-sg__stitle', root), price: $('.ad-sg__sprice', root),
      specs: $('.ad-sg__specs', root), ring: $('.ad-sg__cta-ring', root), details: $('.ad-sg__cta-details', root),
      open360: $('.ad-sg__open360', root), empty: $('.ad-sg__stage-empty', root), body: $('.ad-sg__stage-body', root)
    };
    var stones = [], shown = 80, specCache = {}, selected = null;
    var fullyLoaded = false, loadingAll = false, lastPage = 0;
    var state = { shape: null, carat: null, color: null, clarity: null, sort: 'featured' };

    function tag(p, prefix) {
      var t = (p.tags || []).find(function (x) { return x.indexOf(prefix + ':') === 0; });
      return t ? t.slice(prefix.length + 1) : '';
    }
    function build(p) {
      var img = p.images && p.images[0] ? p.images[0].src : '';
      var m = img.match(/files\/([A-Za-z0-9-]+?)(?:_[0-9a-f-]{8,})?\.(?:jpg|jpeg|png|webp)/i);
      var sid = m ? m[1].toUpperCase() : '';
      var carat = parseFloat((p.title.match(/^([\d.]+)\s*ct/i) || [])[1] || tag(p, 'carat')) || 0;
      var colorTag = tag(p, 'color'), hue = tag(p, 'color-hue'), ctype = tag(p, 'color-type');
      var colorBucket = 'white';
      if (ctype === 'fancy') colorBucket = ['yellow', 'pink', 'blue'].indexOf(hue) > -1 ? hue : 'fancy-other';
      else {
        var cm = (colorTag + ' ' + hue).match(/yellow|pink|blue|green|orange|brown|champagne/i);
        if (cm) { var c0 = cm[0].toLowerCase(); colorBucket = ['yellow','pink','blue'].indexOf(c0) > -1 ? c0 : 'fancy-other'; }
        else {
          // Normal D-to-Z scale: only D through J reads as colorless/near-colorless.
          // K-Z are tinted (faint to light yellow) and must NOT appear under the Colorless chip.
          var g = (colorTag || '').trim().toLowerCase().charAt(0);
          if (g && g >= 'k' && g <= 'z') colorBucket = 'tinted';
        }
      }
      var clarity = (tag(p, 'clarity') || '').toUpperCase();
      var cBucket = /^(FL|IF)/.test(clarity) ? 'flif' : /^VVS/.test(clarity) ? 'vvs' : /^VS/.test(clarity) ? 'vs' : 'si';
      return {
        handle: p.handle, title: p.title, sid: sid, img: img,
        vid: p.variants && p.variants[0] ? p.variants[0].id : null,
        available: p.variants && p.variants[0] ? p.variants[0].available !== false : true,
        price: p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0,
        carat: carat, shape: (function () {
          var shp = tag(p, 'shape');
          if (!shp) {
            var sm = p.title.match(/asscher|princess|radiant|cushion|emerald|marquise|pear|oval|heart|round/i);
            shp = sm ? sm[0].toLowerCase() : 'other';
          }
          return shp;
        })(),
        clarity: clarity, cBucket: cBucket,
        colorBucket: colorBucket, colorLabel: colorTag ? colorTag.replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : '',
        lab: (tag(p, 'lab') || 'IGI').toUpperCase()
      };
    }
    function caratBucket(c) { return c < 1 ? '0.5-1' : c < 1.5 ? '1-1.5' : c < 2 ? '1.5-2' : c < 3 ? '2-3' : '3+'; }

    function filtered() {
      var arr = stones.filter(function (s) {
        if (state.shape && s.shape !== state.shape) return false;
        if (state.carat && caratBucket(s.carat) !== state.carat) return false;
        if (state.color === 'fancy') { if (s.colorBucket === 'white') return false; }
        else if (state.color && s.colorBucket !== state.color) return false;
        if (state.clarity && s.cBucket !== state.clarity) return false;
        return true;
      });
      if (state.sort === 'price-asc') arr.sort(function (a, b) { return a.price - b.price; });
      if (state.sort === 'price-desc') arr.sort(function (a, b) { return b.price - a.price; });
      if (state.sort === 'carat-desc') arr.sort(function (a, b) { return b.carat - a.carat; });
      return arr;
    }

    function shapeLabel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
    function renderList() {
      var arr = filtered();
      countEl.textContent = arr.length.toLocaleString() + (arr.length === 1 ? ' stone' : ' stones');
      listEl.innerHTML = '';
      arr.slice(0, shown).forEach(function (s) {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'ad-sg__row' + (selected && selected.handle === s.handle ? ' is-active' : '');
        row.setAttribute('aria-pressed', (selected && selected.handle === s.handle) ? 'true' : 'false');
        row.innerHTML =
          '<span class="ad-sg__row-thumb">' + (s.img ? '<img src="' + s.img + '&width=96" loading="lazy" alt="" width="48" height="48">' : '') + '</span>' +
          '<span class="ad-sg__row-main"><span class="ad-sg__row-title">' + s.carat.toFixed(2) + ' ct ' + shapeLabel(s.shape) + '</span>' +
          '<span class="ad-sg__row-sub">' + (s.colorLabel || '') + ' · ' + s.clarity + ' · ' + s.lab + '</span></span>' +
          '<span class="ad-sg__row-price">' + money(s.price) + '</span>';
        row.addEventListener('click', function () { select(s, true); });
        listEl.appendChild(row);
      });
      var srcMaster = root.querySelector('.ad-sg__source[hidden]');
      if (srcMaster) {
        var makeCard = function () { var c = srcMaster.cloneNode(true); c.hidden = false; return c; };
        var shownRows = Math.min(arr.length, shown);
        if (arr.length === 0) {
          listEl.appendChild(makeCard());
        } else {
          if (shownRows >= 12) {
            var anchor = listEl.children[8];
            if (anchor) listEl.insertBefore(makeCard(), anchor);
          }
          listEl.appendChild(makeCard());
        }
      }
      moreBtn.style.display = arr.length > shown ? '' : 'none';
      if (!selected && arr.length) select(arr[0], false);
      if (selected && !arr.some(function (s) { return s.handle === selected.handle; }) && arr.length) select(arr[0], false);
    }

    function specRow(label, val, href) {
      if (!val) return '';
      var v = href ? '<a href="' + href + '" target="_blank" rel="noopener">' + val + '</a>' : val;
      return '<div class="ad-sg__spec"><dt>' + label + '</dt><dd>' + v + '</dd></div>';
    }
    function select(s, scroll) {
      selected = s;
      $$('.ad-sg__row', listEl).forEach(function (r) { r.classList.remove('is-active'); });
      stage.empty.style.display = 'none'; stage.body.style.display = '';
      stage.title.textContent = s.carat.toFixed(2) + ' ct ' + shapeLabel(s.shape) + (s.colorLabel ? ', ' + s.colorLabel : '') + ', ' + s.clarity;
      stage.price.textContent = money(s.price);
      stage.ring.href = '/pages/contact?stone=' + encodeURIComponent(s.sid);
      stage.details.href = '/products/' + s.handle;
      var vurl = s.sid ? viewerBase + '/' + s.sid + '.html' : '';
      stage.open360.href = vurl || '#';
      stage.frameWrap.innerHTML = vurl
        ? '<iframe src="' + vurl + '" title="360 view of this diamond" loading="lazy" allowfullscreen></iframe>'
        : (s.img ? '<img src="' + s.img + '" alt="" loading="lazy">' : '');
      stage.specs.innerHTML = '<div class="ad-sg__specs-loading">Loading details…</div>';
      renderList();
      if (scroll && window.matchMedia('(max-width: 989px)').matches) {
        root.querySelector('.ad-sg__stage').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      var h = s.handle;
      (specCache[h] ? Promise.resolve(specCache[h]) : fetch('/products/' + h + '?view=specs').then(function (r) { return r.json(); }).then(function (d) { specCache[h] = d; return d; }))
        .then(function (d) {
          if (selected.handle !== h) return;
          stage.specs.innerHTML =
            specRow('Carat', d.carat) + specRow('Shape', d.shape) + specRow('Color', d.color) +
            specRow('Clarity', d.clarity) + specRow('Cut', d.cut) + specRow('Fluorescence', d.fluorescence) +
            specRow('Measurements', d.measurements) +
            specRow('Table', d.table ? d.table + '%' : '') + specRow('Depth', d.depth ? d.depth + '%' : '') +
            specRow('Polish', d.polish) + specRow('Symmetry', d.symmetry) +
            specRow('Ratio', (d.ratio && parseFloat(d.ratio) > 0) ? d.ratio : '') + specRow('Girdle', d.girdle) + specRow('Culet', d.culet) +
            specRow('Growth', d.growth) +
            specRow('Certificate', d.lab && d.report ? d.lab + ' ' + d.report : d.lab, d.cert_url);
        })
        .catch(function () { stage.specs.innerHTML = ''; });
    }

    function fetchPage(page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = d.products || [];
          stones = stones.concat(ps.map(build).filter(function (s) { return s.img; }));
          lastPage = page;
          renderList();
          return ps.length;
        });
    }
    /* Initial load: 2 pages (~500 stones) — instant browsing without pulling the
       whole ~6.5k-stone catalog up front. */
    function loadInitial() {
      return fetchPage(1).then(function (n1) {
        if (n1 < 250) { fullyLoaded = true; return; }
        return fetchPage(2).then(function (n2) { if (n2 < 250) fullyLoaded = true; });
      });
    }
    /* Load the remaining pages — triggered only when the user filters/sorts or
       pages deep, so accuracy is preserved without the default-load cost. */
    function loadRest() {
      if (fullyLoaded || loadingAll) return Promise.resolve();
      loadingAll = true;
      function next() {
        return fetchPage(lastPage + 1).then(function (n) {
          if (n === 250 && lastPage < 26) return next();
          fullyLoaded = true; loadingAll = false; renderList();
        });
      }
      return next().catch(function () { loadingAll = false; });
    }

    $$('.ad-sg__chip', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var k = chip.getAttribute('data-k'), v = chip.getAttribute('data-v');
        state[k] = (state[k] === v) ? null : v;
        $$('.ad-sg__chip[data-k="' + k + '"]', root).forEach(function (c) { c.classList.toggle('is-active', state[k] === c.getAttribute('data-v')); });
        shown = 80; renderList(); loadRest();
      });
    });
    var reserveBtn = $('.ad-sg__cta-reserve', root);
    if (reserveBtn) reserveBtn.addEventListener('click', function () {
      if (!selected || !selected.vid || reserveBtn.disabled) return;
      reserveBtn.disabled = true; reserveBtn.textContent = 'Reserving\u2026';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: selected.vid, quantity: 1, properties: { 'Stone ID': selected.sid } }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/cart';
      }).catch(function () { reserveBtn.disabled = false; reserveBtn.textContent = 'Reserve This Stone'; });
    });
    var ringBtn = $('.ad-sg__cta-ring', root);
    if (ringBtn) ringBtn.addEventListener('click', function () {
      if (!selected) return;
      try {
        sessionStorage.setItem('ad_stone_inquiry', JSON.stringify({
          id: null, variantId: selected.vid, handle: selected.handle, title: selected.title,
          stoneId: selected.sid, colorType: (selected.colorBucket === 'white' || selected.colorBucket === 'tinted') ? 'colorless' : 'fancy',
          certificate: selected.lab, price: selected.price, carat: selected.carat,
          color: selected.colorLabel || '', clarity: selected.clarity,
          shape: selected.shape.charAt(0).toUpperCase() + selected.shape.slice(1),
          image: selected.img, images: [selected.img], available: selected.available
        }));
      } catch (e) {}
    });
    var sortSel = $('.ad-sg__sort', root);
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; renderList(); loadRest(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += 80; renderList(); loadRest(); });

    (function presetFromURL() {
      var q = new URLSearchParams(location.search);
      var pm = location.pathname.match(/\/shape:([a-z-]+)/i);
      if (pm && !q.get('shape')) q.set('shape', pm[1]);
      var shape = (q.get('shape') || '').toLowerCase();
      var ctype = (q.get('color_type') || q.get('color') || '').toLowerCase();
      var clarity = (q.get('clarity') || '').toLowerCase();
      var carat = q.get('carat') || '';
      if (shape) state.shape = shape;
      if (ctype === 'colorless' || ctype === 'white') state.color = 'white';
      else if (ctype === 'fancy') state.color = 'fancy';
      else if (ctype) state.color = ctype;
      if (clarity) state.clarity = clarity;
      if (carat) state.carat = carat;
      $$('.ad-sg__chip', root).forEach(function (c) {
        var k = c.getAttribute('data-k');
        c.classList.toggle('is-active', state[k] === c.getAttribute('data-v'));
      });
    })();

    var hasPreset = !!(state.shape || state.carat || state.color || state.clarity);
    loadInitial()
      .then(function () { if (hasPreset) return loadRest(); })
      .catch(function () { countEl.textContent = 'Unable to load stones. Refresh to try again.'; });
  }

  function boot() { [].forEach.call(document.querySelectorAll('.ad-sg'), init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
